import React, {useState, useEffect} from 'react';

import parse from 'html-react-parser';
import { boldString } from "../../utils/boldString";
import dataVisibilityHelper from "../../utils/dataVisibilityHelper";

import {
    DataGrid,
    DataGridRow,
    DataGridRowCell
} from "../DataGrid";

import {
    Button
} from "../Button";

const getDataString = (highlightMatches, str, enteredValue) => {
    return highlightMatches && typeof str === 'string' ?
        parse(boldString(str, enteredValue)) :
        str
}

const NestedRow = ({data, highlightMatches, enteredValue}) => {
    if (!data) return null;

    const cells = [];

    const realData = Array.isArray(data[1]) ? data[1] : [];

    for (let i = 0, dataLength = realData.length; i < dataLength; i++) {
        cells.push(
            <DataGridRowCell key={i} colSpan={dataLength === 1 ? '2' : ''}>
                {getDataString(highlightMatches, data[1][i], enteredValue)}
            </DataGridRowCell>
        )
    }
    return (
        <DataGridRow className={data[2] || null}>
            <DataGridRowCell width={'20%'} className={`row-label`} colSpan={!realData.length && 3}>
                {data[0]}
            </DataGridRowCell>
            {cells}
        </DataGridRow>
    )
}

const NestedRowGroup = ({ restData, enteredValue, highlightMatches }) => {
    return (
        <DataGridRow className={'nested-table-row'}>
            <DataGridRowCell
                colSpan={3}
            >
                <div className="address-finder__nested-table">
                    <DataGrid tableAdditionalClass={'nested-table'}>
                        <tbody>
                        {restData.map((e, idx)=>{
                            return (
                                <NestedRow
                                    key={idx}
                                    data={e}
                                    enteredValue={enteredValue}
                                    highlightMatches={highlightMatches}
                                />
                            )
                        })}
                        </tbody>
                    </DataGrid>
                </div>
            </DataGridRowCell>
        </DataGridRow>
    )
}

const AddressFinderRow = ({
    dataLabels,
    columnLabels,
    data,
    index,
    enteredValue,
    highlightMatches,
    defaultOpenAllRows,
    selected,
    onSelect,
    visibleDataLabels,
    visibleColumnLabels,
    language
}) => {
    const [expand, setExpand] = useState(defaultOpenAllRows);
    const [expandStructureFields, setStructureFields] = useState(false);
    const [expandHistoryFields, setHistoryFields] = useState(false);


    useEffect(()=>{
        setExpand(defaultOpenAllRows)
    }, [defaultOpenAllRows])

    const restData = [
        ...(dataVisibilityHelper(visibleDataLabels, "code") ? (
            [[dataLabels['code'][language], [data.code]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "address") ? (
            [[dataLabels['address'][language], [data.address]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "zipCode") ? (
            [[dataLabels['zipCode'][language], [data.zipCode]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "type") ? (
            [[dataLabels['type'][language], [data.typ]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "lksLat") ? (
            [[dataLabels['lksLat'][language], [data.lksLat]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "lksLong") ? (
            [[dataLabels['lksLong'][language], [data.lksLong]]]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "structure") ? (
            [
                [
                    <>
                        <b>
                            {dataLabels['structure'][language]}
                        </b>
                        <span className="ml-4">
                    <Button
                        type={"button"}
                        className={'p-0 btn-height-unset'}
                        spanClass={'px-3'}
                        onClick={()=>{
                            setStructureFields(!expandStructureFields)
                        }}
                    >
                        <i className={`ic-arrow${expandStructureFields ? ' rotate-m180' : ''}`} />
                    </Button>
                </span>
                    </>,
                    []
                ],
                ...(expandStructureFields ? [
                    [dataLabels['city'][language], [data.pilCode, data.pilName, `${data.pilAtvk ? `Atvk: ${data.pilAtvk}` : ""}`], 'rest-row'],
                    [dataLabels['county'][language], [data.novCode, data.novName, `${data.novAtvk ? `Atvk: ${data.novAtvk}` : ""}`], 'rest-row'],
                    [dataLabels['parish'][language], [data.pagCode, data.pagName, `${data.pagAtvk ? `Atvk: ${data.pagAtvk}` : ""}`], 'rest-row'],
                    [dataLabels['village'][language], [data.cieCode, data.cieName], 'rest-row'],
                    [dataLabels['street'][language], [data.ielCode, data.ielName], 'rest-row'],
                    [dataLabels['home'][language], [data.nltCode, data.nltName], 'rest-row'],
                    [dataLabels['apartment'][language], [data.dzvCode, data.dzvName], 'rest-row'],
                ] : []),
            ]
        ) : []),
        ...(dataVisibilityHelper(visibleDataLabels, "history") ? (
            [
                ...(data.history.length ? [
                    [
                        <>
                            <b>
                                {dataLabels['history'][language]}
                            </b>
                            <span className="ml-4">
                    <Button
                        type={"button"}
                        className={'p-0 btn-height-unset'}
                        spanClass={'px-3'}
                        onClick={()=>{
                            setHistoryFields(!expandHistoryFields)
                        }}
                    >
                        <i className={`ic-arrow${expandHistoryFields ? ' rotate-m180' : ''}`} />
                    </Button>
                </span>
                        </>,
                        []
                    ],
                ] : []),
                ...(expandHistoryFields ? data.history.map((hs)=>{
                    return (
                        [getDataString(highlightMatches, hs, enteredValue), null, 'rest-row']
                    )
                }) : []),
            ]
        ) : []),
    ]

    return (
        <React.Fragment>
            <DataGridRow onClick={()=>{
                setExpand(!expand)
            }}>
                {dataVisibilityHelper(visibleColumnLabels, "index") ? (
                    <DataGridRowCell className={'text-nowrap'}>
                        {index + 1}
                    </DataGridRowCell>
                ) : ""}
                {dataVisibilityHelper(visibleColumnLabels, "address") ? (
                    <DataGridRowCell>
                        {getDataString(highlightMatches, data.address, enteredValue)}
                    </DataGridRowCell>
                ) : ""}
                {dataVisibilityHelper(visibleColumnLabels, "code") ? (
                    <DataGridRowCell className={'row-label'}>
                        {getDataString(highlightMatches, data.code, enteredValue)}
                    </DataGridRowCell>
                ) : ""}
                {dataVisibilityHelper(visibleColumnLabels, "selectButton") ? (
                    <DataGridRowCell className={'row-select'}>
                        <Button
                            type={"button"}
                            size={'sm'}
                            spanClass={'text-nowrap'}
                            variant={selected ? 'default' : ''}
                            onClick={(e)=>{
                                e.stopPropagation();
                                onSelect(index)
                            }}
                        >
                            <span className={"normal-label"}>{selected ? columnLabels['selected'][language] : columnLabels['select'][language]}</span>
                            <span className={"mobile-label"}>{selected ? <i className="checkmark"/> : null}</span>
                        </Button>
                    </DataGridRowCell>
                ) : ""}
            </DataGridRow>
            {expand ? (
                <NestedRowGroup
                    enteredValue={enteredValue}
                    highlightMatches={highlightMatches}
                    restData={restData}
                />
            ) : null}
        </React.Fragment>
    )
}

export default AddressFinderRow;